import { BrowserStorageService } from './../../services/browser-storage.service';
import { GlobalConstants } from 'src/app/services/global-variables';
import { Component, Input } from "@angular/core";


@Component({
  selector: 'app-poshvine-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss']
})
export class BadgeComponent{
  @Input() labelText: string | undefined = '';
  @Input() cardLogicEnabled = false;
  @Input() custom = false;
  constructor(private GlobalConstants: GlobalConstants,
    private browserService: BrowserStorageService) {

  }
  ngOnInit() {
    if (this.cardLogicEnabled) {
      this.labelText = this.evaluateApplicableCard();
    }
  }
  evaluateApplicableCard() {
    const returnText = (): string => {
      if (this.browserService.get('userCard')) {
        let currentUserCard = JSON.parse(this.browserService.get('userCard'));
        return `${this.GlobalConstants.data.legal_name} ${currentUserCard.attributes.card_type}`;
      }
      else if (this.browserService.get('selectedCardType')) {
        return `${this.GlobalConstants.data.legal_name} ${this.browserService.get('selectedCardType') == 'credit-cards' ? 'Credit' : 'Debit'}`;
      }
      else {
        return `${this.GlobalConstants.data.legal_name} ${this.GlobalConstants.data.x_header.default_card_type == 'credit' ? 'Credit' : 'Debit'}`;
      }
    }

    return `Applicable on ${returnText()} Card`;
  }
}
